import {useQuery} from '@tanstack/react-query';
import {ACCOUNT_TYPE_TO_DV_MAPPING} from '@/constants/engine';
import {getInvestorById} from '@/repositories/beneva-api/endpoints/client-info';
import {InvestorAccount} from '@/types/client-info';

export const useGetInvestorByIdQuery = (investorNo: string | undefined) =>
  useQuery({
    queryKey: ['getInvestorById', investorNo],
    queryFn: async () => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const {data: investor} = await getInvestorById(investorNo!);

      // Filter accounts to only include those with offered by BMW
      if (investor) {
        investor.accounts = (investor.accounts ?? []).filter(availableAccountTypesFilter);
      }

      return investor;
    },
    enabled: !!investorNo,
    retry: false,
    refetchOnWindowFocus: false,
  });

const availableAccountTypesFilter = (account: Pick<InvestorAccount, 'acctType'>) =>
  Object.keys(ACCOUNT_TYPE_TO_DV_MAPPING).includes(account.acctType);
